import React from 'react';
import i18n from '../../../../../../utils/ChrI18n';
import { keyBoardAccessibilityAttributes } from '../../../../../../utils/GeneralUtils';

const Content = props => {
  return(
    <>
      <span dangerouslySetInnerHTML={{__html: props.truncatedText }}/>
      {
        props.displayShowMore && <a
          { ...props.linkAttributes }
          dangerouslySetInnerHTML={{__html: i18n.t('display_string.show_more_raquo_html')}}
          { ...keyBoardAccessibilityAttributes }
        />
      }
    </>
  )
}

const Description = ({ description, linkAttributes, showRightPaneContent }) => {
  return(
    <div className="break-word-all">
      <span className={ `d-none ${showRightPaneContent ? 'd-md' : 'd-sm'}-inline` }>
        <Content
          truncatedText={ description.web.truncatedText }
          displayShowMore={ description.web.displayShowMore }
          linkAttributes={ linkAttributes }
        />
      </span>
      <span className={ showRightPaneContent ? 'd-md-none' : 'd-sm-none' }>
        <Content
          truncatedText={ description.mobile.truncatedText }
          displayShowMore={ description.mobile.displayShowMore }
          linkAttributes={ linkAttributes }
        />
      </span>
    </div>
  );
}

export default Description;